(function() {
    'use strict';

    angular.module('app.bancos', []);
})();
